import {
  checkAllSliderGroupsCorrect,
  resetUpdatedKeyInDNDQ,
  VISIBILITY,
} from '@learningblocks/protocol-constants/lib/Utilities';
const NEXT_COMPONENT = 'nextComponent';

export function submitGroupedDNDQAnswer(state, payload) {
  return {
    ...state,
    currentSection: updateInCurrentSection(state.currentSection, payload),
  };
}

function updateInCurrentSection(currentSection, payload) {
  return {
    ...currentSection,
    components: updateInComponents(currentSection.components, payload),
  };
}

function updateInComponents(components, payload) {
  const {newcomponents} = components.reduce(
    (acc, component) => {
      //updating Submitted component
      if (component.id === payload.componentID) {
        component = updateInGroupedDNDQ(component);
        if (component.hasOwnProperty(NEXT_COMPONENT)) {
          acc.forward = {
            complete: component.complete,
            nextComponent: component.nextComponent,
          };
        }
      }

      // updating forward component and setting its visibility
      if (
        acc.forward &&
        acc.forward.complete &&
        acc.forward.nextComponent === component.id
      ) {
        component = {...component, visibility: VISIBILITY.VISIBLE};
        acc.forward = null;
      }
      acc.newcomponents = [...acc.newcomponents, component];
      return acc;
    },
    {
      newcomponents: [],
      forward: null,
    }
  );
  return newcomponents;
}

function updateInGroupedDNDQ(component) {
  if (component.totalAttempts === -10 || component.totalAttempts > 0) {
    const complete = checkAllSliderGroupsCorrect(component.sliderGroups);
    let sliderGroups = resetUpdatedKeyInDNDQ(component.sliderGroups);
    if (complete) {
      sliderGroups = disableAllSliders(sliderGroups);
    }
    const totalAttempts =
      component.totalAttempts === -10 ? -10 : component.totalAttempts - 1;
    return {
      ...component,
      complete,
      sliderGroups,
      totalAttempts,
      showFeedback: true,
    };
  } else {
    return {
      ...component,
      complete: true,
      showFeedback: true,
      totalAttempts: 0,
    };
  }
}

function disableAllSliders(sliderGroups) {
  return sliderGroups.map((group) => {
    return {
      ...group,
      sliders: group.sliders.map((slider) => ({...slider, disable: true})),
    };
  });
}


